import { Label as LabelPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

import { cn } from './cn';

/** Rótulo de campo (Radix Label: clicar foca o controle). */
export function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-[calc(var(--lume-field-fs)-1px)] leading-tight font-medium text-foreground select-none peer-disabled:opacity-60',
        className,
      )}
      {...props}
    />
  );
}
